// filo-takip/src/pages/FiloAdminPage.js
import React, { useEffect, useState } from "react";
import { db } from "../firebaseConfig";
import { collection, getDocs, updateDoc, doc } from "firebase/firestore";
import Select from "react-select";

const FiloAdminPage = () => {
  const [plates,   setPlates]   = useState([]);
  const [persons,  setPersons]  = useState([]);  // personeller koleksiyonu
  const [tesisler, setTesisler] = useState([]);  // plates'ten türetilen tesis listesi

  // Form state — personel modülüyle birebir aynı alan adları
  const [selPersonOpt,     setSelPersonOpt]     = useState(null);
  const [selPersonTesis,   setSelPersonTesis]   = useState("");
  const [selPersonEmail,   setSelPersonEmail]   = useState("");
  const [selPersonGorTes,  setSelPersonGorTes]  = useState([]);
  const [savingAccess,     setSavingAccess]     = useState(false);

  /* ---- veri çek ---- */
  const refreshPersons = async () => {
    const snap = await getDocs(collection(db, "personeller"));
    setPersons(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  };

  useEffect(() => {
    (async () => {
      try {
        const [pSnap] = await Promise.all([
          getDocs(collection(db, "plates")),
        ]);
        const platesData = pSnap.docs.map(d => ({ id: d.id, ...d.data() }));
        setPlates(platesData);

        // Tesis listesi plates'ten türet
        const ts = new Set();
        platesData.forEach(p => p.tesis && ts.add(String(p.tesis).trim()));
        setTesisler([...ts].sort((a, b) => a.localeCompare(b, "tr")));

        await refreshPersons();
      } catch (e) { console.error("[FiloAdminPage]", e); }
    })();
  }, []);

  /* ---- personel seçilince ---- */
  const handlePersonSelect = (opt) => {
    setSelPersonOpt(opt);
    if (!opt) { setSelPersonTesis(""); setSelPersonEmail(""); setSelPersonGorTes([]); return; }
    const p = persons.find(x => x.id === opt.value);
    // gorebilecegiFiloTesisler — filo modülüne özgü, personel modülündeki gorebilecegiTesisler'den AYRI
    const gt = Array.isArray(p?.gorebilecegiFiloTesisler) ? p.gorebilecegiFiloTesisler : [];
    setSelPersonTesis(p?.tesis || "");
    setSelPersonEmail(p?.email || "");
    setSelPersonGorTes(gt.map(t => ({ value: t, label: t })));
  };

  /* ---- kaydet ---- */
  const handleSave = async () => {
    if (!selPersonOpt) return alert("Önce personel seçin.");
    setSavingAccess(true);
    try {
      const pid      = selPersonOpt.value;
      const newEmail = String(selPersonEmail || "").trim();
      const newList  = (selPersonGorTes || []).map(o => String(o.value));
      // personeller koleksiyonuna yaz — gorebilecegiFiloTesisler (filo'ya özgü)
      await updateDoc(doc(db, "personeller", pid), {
        email:                    newEmail,
        gorebilecegiFiloTesisler: newList,
      });
      setPersons(prev => prev.map(p =>
        p.id !== pid ? p : ({ ...p, email: newEmail, gorebilecegiFiloTesisler: newList })
      ));
      alert("✅ Erişim bilgileri güncellendi.");
      setSelPersonOpt(null); setSelPersonTesis(""); setSelPersonEmail(""); setSelPersonGorTes([]);
    } catch (e) { console.error(e); alert("❌ Kaydetme sırasında hata oluştu."); }
    finally { setSavingAccess(false); }
  };

  /* ---- email sil ---- */
  const handleDeleteEmail = async (pid) => {
    try {
      await updateDoc(doc(db, "personeller", pid), { email: "" });
      setPersons(prev => prev.map(p => p.id !== pid ? p : ({ ...p, email: "" })));
    } catch (e) { console.error(e); alert("❌ Email silinemedi."); }
  };

  /* ---- listeler ---- */
  // Personel modülündeki gibi: email field'ı dolu olanlar
  const emailPersons = persons
    .filter(p => (p.email || "").trim() !== "")
    .sort((a, b) =>
      (a.ad || "").localeCompare(b.ad || "", "tr") ||
      (a.soyad || "").localeCompare(b.soyad || "", "tr")
    );

  const personOptions = persons
    .filter(p => p.aktif !== false)
    .sort((a, b) =>
      (a.ad || "").localeCompare(b.ad || "", "tr") ||
      (a.soyad || "").localeCompare(b.soyad || "", "tr")
    )
    .map(p => ({ value: p.id, label: `${p.ad || ""} ${p.soyad || ""}`.trim() }));

  // Tesis seçenekleri — personeller'deki tesis field'larından (plates'teki gibi)
  const tesisOptions = tesisler.map(t => ({ value: t, label: t }));

  return (
    <div style={{ padding: 20, maxWidth: 1200, margin: "auto", fontFamily: 'system-ui,-apple-system,"Segoe UI",Roboto,Arial' }}>
      <style>{`
        .panel  { border:1px solid #e5e7eb; border-radius:10px; padding:16px; margin:18px 0; background:#fff }
        .h      { font-weight:700; margin:0 0 12px 0; font-size:15px }
        .row    { display:flex; gap:12px; flex-wrap:wrap; align-items:flex-end }
        .btn    { padding:10px 16px; background:#1e40af; color:#fff; border:none; border-radius:6px; cursor:pointer; font-size:13px }
        .btn.gray { background:#6b7280 }
        .btn.red  { background:#dc2626 }
        .inp    { padding:8px 10px; border:1px solid #d1d5db; border-radius:6px; font-size:13px; box-sizing:border-box }
        .table  { width:100%; border-collapse:collapse }
        .table th, .table td { border:1px solid #e5e7eb; padding:8px; text-align:left; vertical-align:top; font-size:13px }
        .table th { background:#f8fafc; font-weight:700 }
        .muted  { color:#64748b; font-size:13px }
      `}</style>

      <h2 style={{ marginBottom: 4 }}>Filo Takip — Admin Paneli</h2>
      <p className="muted" style={{ marginBottom: 20 }}>
        Personele filo erişim emaili ve ek tesis görüntüleme yetkisi tanımlayın.
        Ek tesis verilmeyen personel yalnızca kendi bağlı olduğu tesisteki araçları görür.
        Email eşleşmesi olmayan kullanıcılar hiçbir araç göremez.
      </p>

      {/* ========== PERSONEL ERİŞİMİ — personel modülüyle birebir aynı ========== */}
      <div className="panel">
        <h3 className="h">Personel Erişimi (Email & Görebileceği Filo Tesisleri)</h3>

        <div className="row" style={{ alignItems: "flex-end" }}>

          <div>
            <div style={{ fontWeight: 600, marginBottom: 6 }}>İsim (pasifler listelenmez)</div>
            <Select
              options={personOptions}
              value={selPersonOpt}
              onChange={handlePersonSelect}
              placeholder="Personel ara ve seç…"
              isSearchable
              menuPortalTarget={typeof document !== "undefined" ? document.body : null}
              styles={{ menuPortal: b => ({ ...b, zIndex: 9999 }), control: b => ({ ...b, minWidth: 280 }) }}
            />
          </div>

          <div>
            <div style={{ fontWeight: 600, marginBottom: 6 }}>Tesis</div>
            <input className="inp" value={selPersonTesis} readOnly style={{ minWidth: 140 }} />
          </div>

          <div>
            <div style={{ fontWeight: 600, marginBottom: 6 }}>Görebileceği Filo Tesisleri</div>
            <Select
              isMulti
              options={tesisOptions}
              value={selPersonGorTes}
              onChange={v => setSelPersonGorTes(v || [])}
              placeholder="Tesis seç…"
              isSearchable
              closeMenuOnSelect={false}
              menuPortalTarget={typeof document !== "undefined" ? document.body : null}
              styles={{ menuPortal: b => ({ ...b, zIndex: 9999 }), control: b => ({ ...b, minWidth: 280 }) }}
            />
          </div>

          <div>
            <div style={{ fontWeight: 600, marginBottom: 6 }}>Email</div>
            <input
              className="inp"
              value={selPersonEmail}
              onChange={e => setSelPersonEmail(e.target.value)}
              placeholder="ornek@firma.com"
              style={{ minWidth: 260 }}
            />
          </div>

          <button className="btn" onClick={handleSave} disabled={savingAccess}>
            {savingAccess ? "Kaydediliyor…" : "Kaydet"}
          </button>
        </div>

        {/* ---- Email girilmiş personeller listesi ---- */}
        <div style={{ marginTop: 16 }}>
          <div style={{ fontWeight: 700, marginBottom: 8 }}>Email girilmiş personeller</div>
          {emailPersons.length === 0 ? (
            <div className="muted">Henüz email atanmış personel yok.</div>
          ) : (
            <table className="table">
              <thead>
                <tr>
                  <th>Ad Soyad</th>
                  <th>Tesis</th>
                  <th>Email</th>
                  <th>Görebileceği Filo Tesisleri</th>
                  <th>İşlem</th>
                </tr>
              </thead>
              <tbody>
                {emailPersons.map(p => (
                  <tr key={p.id}>
                    <td>{`${p.ad || ""} ${p.soyad || ""}`.trim()}</td>
                    <td>{p.tesis || "—"}</td>
                    <td>{p.email}</td>
                    <td>
                      {Array.isArray(p.gorebilecegiFiloTesisler) && p.gorebilecegiFiloTesisler.length > 0
                        ? p.gorebilecegiFiloTesisler.join(", ")
                        : "—"}
                    </td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      <button
                        className="btn gray"
                        onClick={() => {
                          const opt = { value: p.id, label: `${p.ad || ""} ${p.soyad || ""}`.trim() };
                          setSelPersonOpt(opt);
                          setSelPersonTesis(p.tesis || "");
                          setSelPersonEmail(p.email || "");
                          setSelPersonGorTes((p.gorebilecegiFiloTesisler || []).map(t => ({ value: t, label: t })));
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                      >Düzenle</button>
                      &nbsp;
                      <button className="btn red" onClick={() => handleDeleteEmail(p.id)}>
                        Emaili Sil
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* ========== TESİSLER BİLGİ PANELİ ========== */}
      <div className="panel">
        <div className="h">Tesisler ve Aktif Araç Sayıları</div>
        <table className="table">
          <thead><tr><th>Tesis</th><th>Aktif Araç</th></tr></thead>
          <tbody>
            {tesisler.map(t => (
              <tr key={t}>
                <td>{t}</td>
                <td>{plates.filter(p =>
                  String(p.tesis || "").trim() === t && p.active !== false
                ).length}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FiloAdminPage;